import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Physicians from './Physicians';
import PhysicianAdd from './PhysicianAdd/PhysicianAdd';
import Physician from './Physician/Physician';
import GiveAccess from './Physician/GiveAccess/GiveAccess';

export const PhysiciansRoutes = (
  <Route path="physicians" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Health']}>
          <Physicians />
        </PrivateRoute>
            )}
    />

    <Route
      path="add"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Health']}>
          <PhysicianAdd />
        </PrivateRoute>
          )}
    />

    <Route
      path=":physicianId"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Physician', 'Health']}>
          <Physician />
        </PrivateRoute>
          )}
    />

    <Route
      path=":physicianId/edit"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Health']}>
          <PhysicianAdd edit />
        </PrivateRoute>
          )}
    />

    <Route
      path=":physicianId/access"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Health']}>
          <GiveAccess />
        </PrivateRoute>
          )}
    />

    <Route
      path="groups/:groupName"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Health']}>
          <Physician type="group" />
        </PrivateRoute>
          )}
    />

    <Route
      path="groups/:groupName/access"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep']}>
          <GiveAccess group />
        </PrivateRoute>
          )}
    />
  </Route>
);
